module.exports = __webpack_public_path__ + "assets/img/The-Dream-Collective-Website-w960.9561c24c.webp";